import { Services } from "../services/Services";
import { ContestEntryDO } from "./ContestEntryDO";
import { DateTime, Duration } from "luxon";

export class ContestManager {
	static get entries(){ return ContestManager._entries; }
	private static _entries:ContestEntryDO[] = [];
	
	public static async getEntries(dateId:string):Promise<void> {
		let rdto = await Services.getContestData(dateId);
		if (rdto.success){
			this._entries = rdto.dataList.map((dto) => 
				ContestEntryDO.fromContestDto(dto));
		}
	}
	
	/**constructs an id string used to identify a competition in
	 * the database. The form of the string is Month/Day/Year (ex. 12/17/2019)*/
	public static getCompetitionId(startDate:DateTime = null, 
			weekIndex:number = 0):string {
		if (startDate == null){
			startDate = ContestManager.getCompetitionStartDate(weekIndex);
		}
		return `${startDate.month}-${startDate.day}-${startDate.year}`;
	}
	
	/**The [weekDelta] is the number of weeks to go backwards in
	 * time. 0 means the current week/competition.*/
	public static getCompetitionStartDate(weekDelta:number):DateTime {
		//calculate the day the competition started
		let now = DateTime.utc();
		let weekday:number = now.weekday;
		let daysDelta:number = (weekday - 1) + weekDelta * 7;
		let duration = Duration.fromObject({ days: daysDelta});
		let startDate = now.minus(duration);
		return startDate;
	}
}